import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import { DOMAIN, IsDev } from '../util/env';
import { Constants } from '@fibl/oxs-common';

export default function init(websiteCode: Constants.WebConstant) {
	//https://prazdevs.github.io/pinia-plugin-persistedstate/guide/config.html
	const persistence = createPersistedState({
		key: (id) => `${DOMAIN}_${websiteCode}_store_${id}`,
		storage: window.localStorage,
	});

	const plugins = IsDev ? [persistence] : [persistence];

	const pinia = createPinia();

	plugins.forEach((plugin) => {
		pinia.use(plugin);
	});

	return pinia;
}
